import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  styled,
} from '@mui/material'
import DateFormatter from '@/utilities/date-formatter'
import { AreaControllerData } from '@/utilities/types/table'

interface ViewAreaControllerModalProps {
  open: boolean
  onClose: () => void
  data: AreaControllerData | null
}

export const ModalContainer = styled(Box)({
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  height: `calc(100% - 120px)`,
  flex: 1,
  overflow: 'auto',
  position: 'relative',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
})

const ViewAreaControllerModal = ({
  open,
  onClose,
  data,
}: ViewAreaControllerModalProps) => {
  if (!data) return null

  const fields = [
    { label: 'ID', value: data.id },
    { label: 'Name', value: `${data.firstName} ${data.lastName}` },

    {
      label: 'Created Date',
      value: <DateFormatter dateString={data.dateCreated} />,
    },
    {
      label: 'Modified Date',
      value: <DateFormatter dateString={data.dateModified} />,
    },
    // {
    //   label: 'Assigned Areas',
    //   value:
    //     data.userAreas.length > 0
    //       data.userAreas.map((area) => area.area.name).join(', ')
    //       : '-',
    // },
  ]

  console.log('thisisdata', data)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Area Controller Details</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          {fields.map((field, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography
                variant="caption"
                component="div"
                sx={{
                  color: 'text.secondary',
                  mb: 0.5,
                }}
              >
                {field.label}
              </Typography>
              <Typography variant="body2">{field.value}</Typography>
              {index < fields.length - 1 && <Divider sx={{ mt: 2 }} />}
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          sx={{
            width: {
              xs: '100%',
              sm: '100%',
              md: '100%',
              lg: 'auto',
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewAreaControllerModal
